import { useQuery } from '@tanstack/react-query';
import { mealPlanService } from '@/services/mealPlan';
import { format } from 'date-fns';
import { getMealPlansQueryKey } from '@/constants/queryKeys';

export const useMealPlans = (startDate: Date, endDate: Date, familyId?: string) => {
  const startDateStr = format(startDate, 'yyyy-MM-dd');
  const endDateStr = format(endDate, 'yyyy-MM-dd');

  return useQuery({
    queryKey: getMealPlansQueryKey(startDateStr, endDateStr, familyId),
    queryFn: () => mealPlanService.getMealPlans(startDate, endDate),
    enabled: !!familyId,
    staleTime: 0, // Always fresh for immediate updates
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};